import {
  AutocompleteDropdown,
  AutocompleteMultiDropdown,
  CommonDropdown,
  SimpleDropdown,
} from "@/components";
import React from "react";
import {
  array,
  bool,
  string,
  oneOfType,
  oneOf,
  func,
  object,
} from "prop-types";
import type { SxProps, Theme } from "@mui/material";
import type { DropdownOption } from "@/types";

type SelectDropdownProps = {
  options: DropdownOption[];
  required?: boolean;
  componentLabel?: string;
  defaultValue?: string | number | string[];
  showAll?: boolean;
  allPosition?: "start" | "end";
  onChange?: (event: DropdownOption) => void;
  visualStyle: "autoComplete" | "autoCompleteMulti" | "simple" | "old";
  sx?: SxProps<Theme>;
  cacheKey?: string;
  refetch?: boolean;
  refetched?: () => void;
  disableCache?: boolean;
};

export const SelectDropdown = (props: SelectDropdownProps) => {
  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown
          required={props.required}
          options={props.options}
          componentLabel={props.componentLabel}
          showAll={props.showAll}
          allPosition={props.allPosition}
          defaultValue={props.defaultValue as string | number}
          onChange={props.onChange}
          cacheKey={props.cacheKey}
          size="small"
          sx={{
            ...props.sx,
          }}
        />
      )}

      {props.visualStyle === "autoCompleteMulti" && (
        <AutocompleteMultiDropdown
          required={props.required}
          options={props.options}
          componentLabel={props.componentLabel}
          showAll={props.showAll}
          defaultValue={props.defaultValue as (string | number)[]}
          onChange={props.onChange}
          size="small"
          sx={{
            ...props.sx,
          }}
        />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown
          required={props.required}
          options={props.options}
          componentLabel={props.componentLabel}
          showAll={props.showAll}
          defaultValue={props.defaultValue as string}
          onChange={props.onChange}
          disableCache={props.disableCache}
          sx={{
            ...props.sx,
          }}
        />
      )}

      {props.visualStyle === "old" && (
        <CommonDropdown
          required={props.required}
          options={props.options}
          componentLabel={props.componentLabel}
          showAll={props.showAll}
          defaultValue={props.defaultValue as string}
          onChange={props.onChange}
          sx={{
            ...props.sx,
          }}
        />
      )}
    </>
  );
};

SelectDropdown.propTypes = {
  options: array.isRequired,
  required: bool,
  componentLabel: string.isRequired,
  defaultValue: oneOfType([string, array]).isRequired,
  showAll: bool,
  allPosition: oneOf(["start", "end"]),
  onChange: func.isRequired,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"])
    .isRequired,
  sx: object,
  cacheKey: string,
  refetch: bool,
  refetched: func,
  disableCache: bool,
};
